import type { GqlQuery, GqlQueryPartial } from './gql-tag.ts';
import { PopularCities, PopularCitiesVariables } from '../../types/graphql-types-generated.ts';
import { AppContext } from '../app-context/app-context.tsx';
import { IGraphQLQueryError, IGraphQLResponse } from './graphql-service.ts';

/**
 * Returns the query depending on the input.
 *
 * When "query" is a string, the string itself is used. Otherwise a query consisting of the query itself and all its
 * dependencies (deduped) is returned.
 * @param query
 */
export const buildQuery = (
  query: (
    variables: PopularCitiesVariables,
    appContext: AppContext
  ) => Promise<IGraphQLResponse<PopularCities, IGraphQLQueryError>>
): string => {
  if (typeof query === 'string') {
    return query;
  } else {
    const partials = collectPartials(query);

    return `
      ${query.gqlQuery}

      ${Array.from(partials).map(partial => partial.gqlPartial)}
    `;
  }
};

/**
 * Collects all partial dependencies recursively. Removes duplicated dependencies.
 */
const collectPartials = (query: GqlQuery | GqlQueryPartial): Set<GqlQueryPartial> => {
  if (query.partials) {
    const partials = query.partials
      .map(collectPartials)
      .map(partials => Array.from(partials))
      .reduce((acc, p) => acc.concat(p));

    return new Set(query.partials.concat(partials));
  }

  return new Set();
};
